import { TRIGGER_API_FETCH, FETCH_WISHES_SUCCESS, FETCH_WISHES_FAILURE } from '../actions/wishesActions';

const initialState = {
  shouldCallFetchWish: true,
  error: null,
};

const wishesReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_API_FETCH:
        return {
        ...state,
        shouldCallFetchWish: true,
        };
    case FETCH_WISHES_SUCCESS:
        return {
        ...state,
        shouldCallFetchWish: false,
        };
    case FETCH_WISHES_FAILURE:
        return {
        ...state,
        shouldCallFetchWish: false,
        error: action.payload,
        };
    default:
      return state;
  }
};

export default wishesReducer;
